import { type SubscriptionBillingCycle } from '@air/api/types';

export const PLAN_CYCLE_COPY: { [key in SubscriptionBillingCycle]: string } = {
  annual: 'Yearly',
  monthly: 'Monthly',
  quarter: 'Quarterly',
  semiAnnual: 'Semi-Annually',
};

export const PLAN_CYCLE_UNIT: { [key in SubscriptionBillingCycle]: string } = {
  annual: 'year',
  monthly: 'month',
  quarter: 'quarter',
  semiAnnual: '6 months',
};

export const PLAN_CYCLE_MONTHS: { [key in SubscriptionBillingCycle]: number } = {
  monthly: 1,
  quarter: 3,
  semiAnnual: 6,
  annual: 12,
};
